import { getBlob } from 'shared/lib/getBlob'
import { downloadBlob } from 'shared/lib/downloadBlob'

export function downloadFile(url: string, name?: string) {
  void getBlob(url, (blob) => downloadBlob(blob, name))
}
